const types = {
  UPDATE_NAV_STACK: 'NAV/UPDATE_NAV_STACK',
};

export default types;
